import type { paths } from '@front/generated/apiClient';
import { createQantApiClient } from 'auth-lib-front';
import type { Client } from 'openapi-fetch';
import { Env } from 'troppus-common/shared';

let _apiClient: ReturnType<typeof createQantApiClient<paths>> | null = null;

export const getApiClient = (): Client<paths> => {
  if (_apiClient) {
    return _apiClient;
  }

  _apiClient = createQantApiClient<paths>({
    baseUrl: Env.Var.Api.Domain,
  });

  return _apiClient;
};
